import { createFileRoute, Link } from "@tanstack/react-router"

import { PageHeader } from "@/components/common/page-header"
import { PageContent } from "@/components/common/page-content"
import { Button } from "@/components/ui/button"
import { IndividualAddresses } from "@/features/individuals/components/individual-addresses"
import { countryQueries } from "@/queries/countries"
import { individualQueries } from "@/queries/individuals"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/individuals/$individualId/addresses/"
)({
  staticData: { attention: "individual.addresses" },
  loader: async ({ context, params }) => {
    await Promise.all([
      context.queryClient.ensureQueryData(
        individualQueries.addresses(params.individualId)
      ),
      context.queryClient.ensureQueryData(countryQueries.list()),
    ])
  },
  component: IndividualAddressesPage,
})

function IndividualAddressesPage() {
  const { individualId } = Route.useParams()

  return (
    <>
      <PageHeader
        title="Addresses"
        actions={
          <Button
            nativeButton={false}
            render={
              <Link
                from="/$organisation"
                to="/$organisation/individuals/$individualId/addresses/edit"
                params={{ individualId }}
              >
                Update addresses
              </Link>
            }
          />
        }
      />

      <PageContent>
        <IndividualAddresses individualId={individualId} />
      </PageContent>
    </>
  )
}
